export default __webpack_public_path__ + "static/media/eTraining.fda1b1fb.jpg";